import { motion } from "framer-motion";
import "../component css/SkillsCarousel.css";

const DEVICON = (slug) =>
  `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${slug}/${slug}-original.svg`;

const ROWS = [
  {
    label: "Languages",
    tag: "08 SKILLS",
    dir: "left",
    duration: 46,
    items: [
      ["HTML",       "html5",      "HT"],
      ["CSS",        "",           "CSS"],
      ["JavaScript", "javascript", "JS"],
      ["TypeScript", "typescript", "TS"],
      ["Python",     "python",     "Py"],
      ["PHP",        "php",        "PHP"],
      ["C++",        "cplusplus",  "C++"],
      ["SQL",        "",           "SQL"],
    ],
  },
  {
    label: "Frameworks & Tools",
    tag: "09 SKILLS",
    dir: "right",
    duration: 54,
    items: [
      ["React",       "react",     "Re"],
      ["Node.js",     "nodejs",    "No"],
      ["Next.js",     "nextjs",    "Nx"],
      ["Bootstrap",   "bootstrap", "Bs"],
      ["WordPress",   "wordpress", "WP"],
      ["Git / GitHub","",          "Git"],
      ["MySQL",       "mysql",     "My"],
      ["Figma",       "figma",     "Fig"],
      ["VS Code",     "",          "VS"],
    ],
  },
  {
    label: "Platforms & Creative",
    tag: "09 SKILLS",
    dir: "left",
    duration: 60,
    items: [
      ["Linux",        "linux", "Lx"],
      ["Windows",      "",      "Win"],
      ["iOS",          "",      "iOS"],
      ["Photoshop",    "",      "Ps"],
      ["Illustrator",  "",      "Ai"],
      ["InDesign",     "",      "Id"],
      ["After Effects","",      "Ae"],
      ["Premiere Pro", "",      "Pr"],
      ["Canva",        "",      "Cv"],
    ],
  },
  {
    label: "Artificial Intelligence",
    tag: "04 SKILLS",
    dir: "right",
    duration: 38,
    items: [
      ["Claude",  "",  "Cl"],
      ["ChatGPT", "",  "GPT"],
      ["Gemini",  "",  "Gm"],
      ["Codex",   "",  "Cx"],
    ],
  },
];

const SOFT = ["Leadership", "Communication", "Teamwork", "Problem Solving", "Adaptability"];

function Tile({ name, slug, mono }) {
  const iconUrl = slug ? DEVICON(slug) : null;
  return (
    <div className="skill-tile">
      <span className="skill-tile__icon">
        {iconUrl ? (
          <img
            src={iconUrl}
            alt={name}
            className="skill-tile__icon-img"
            loading="lazy"
          />
        ) : (
          <span className="skill-tile__mono">{mono}</span>
        )}
      </span>
      <span className="skill-tile__name">{name}</span>
    </div>
  );
}

function MarqueeRow({ label, tag, items, dir, duration }) {
  const loop = [...items, ...items];
  const from = dir === "left" ? "0%" : "-50%";
  const to   = dir === "left" ? "-50%" : "0%";

  return (
    <div className="marquee-row">
      <div className="marquee-row__label">
        {label}
        <span className="marquee-row__tag">{tag}</span>
      </div>
      <div className="marquee-row__track">
        <motion.div
          className="marquee-row__inner"
          animate={{ x: [from, to] }}
          transition={{ duration, ease: "linear", repeat: Infinity }}
        >
          {loop.map((it, i) => (
            <Tile key={`${it[0]}-${i}`} name={it[0]} slug={it[1]} mono={it[2]} />
          ))}
        </motion.div>
      </div>
    </div>
  );
}

export default function SkillsCarousel() {
  return (
    <section className="skills-carousel">
      <div className="skills-carousel__heading">
        <h2>Skills &amp; Strengths</h2>
        <span className="skills-carousel__underline" />
        <p>
          The tools and disciplines I bring to every project, spanning
          engineering, design, AI and the way I work with people.
        </p>
      </div>

      <motion.div
        className="skills-carousel__rows"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
        variants={{ show: { transition: { staggerChildren: 0.14 } } }}
      >
        {ROWS.map((row) => (
          <motion.div
            key={row.label}
            variants={{
              hidden: { opacity: 0, y: 16 },
              show:   { opacity: 1, y: 0, transition: { duration: 0.65 } },
            }}
          >
            <MarqueeRow {...row} />
          </motion.div>
        ))}
      </motion.div>

      <div className="skills-carousel__soft">
        <div className="skills-carousel__soft-heading">
          <span className="skills-carousel__soft-title">Soft Skills</span>
          <span className="skills-carousel__soft-count">05</span>
        </div>
        <div className="skills-carousel__soft-pills">
          {SOFT.map((s, i) => (
            <motion.span
              key={s}
              className="soft-pill"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.55 + i * 0.06, duration: 0.5 }}
            >
              <span className="soft-pill__diamond" />
              {s}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
